var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconLaunchFlip(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "198.011 135.812 18 18",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M 214.011 151.812 L 200.011 151.812 L 200.011 137.812 L 207.011 137.812 L 207.011 135.812 L 200.011 135.812 C 198.901 135.812 198.011 136.712 198.011 137.812 L 198.011 151.812 C 198.011 152.912 198.901 153.812 200.011 153.812 L 214.011 153.812 C 215.111 153.812 216.011 152.912 216.011 151.812 L 216.011 144.812 L 214.011 144.812 L 214.011 151.812 Z M 209.011 135.812 L 209.011 137.812 L 212.601 137.812 L 202.771 147.642 L 204.181 149.052 L 214.011 139.222 L 214.011 142.812 L 216.011 142.812 L 216.011 135.812 L 209.011 135.812 Z",
    fill: "#073c7a",
    transform: "matrix(-1, 0, 0, -1, 414.022003, 289.623993)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLaunchFlip);
export default __webpack_public_path__ + "static/media/icon_launch_flip.8c385c4f6e271d913e0c8fff8ff6d367.svg";
export { ForwardRef as ReactComponent };